import { Injectable } from '@angular/core'
const UTM_STORAGE_PREFIX = '_gx_utm'
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

@Injectable({ providedIn: 'root' })
export class UTMService {
  constructor() {}

  init(): void {
    if (window.location.search) {
      let utmData: any = {}
      window.location.search.split('&').forEach((str) => {
        UTM_KEYS.forEach((key) => {
          if (str.includes(key + '=')) {
            utmData = { ...utmData, [key]: encodeURIComponent(str.split(key + '=')[1]) }
          }
        })
      })

      if (Object.keys(utmData).length) {
        window.localStorage.setItem(UTM_STORAGE_PREFIX, JSON.stringify(utmData))
      }
    }
  }

  getUTMData(): any {
    const utmDataStr = window.localStorage.getItem(UTM_STORAGE_PREFIX)
    return utmDataStr ? JSON.parse(utmDataStr) : utmDataStr
  }

  remove(): void {
    window.localStorage.removeItem(UTM_STORAGE_PREFIX)
  }

  set(utmData: any): void {
    if (Object.keys(utmData).length) {
      window.localStorage.setItem(UTM_STORAGE_PREFIX, JSON.stringify(utmData))
    }
  }
}
